import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { SummarySendMail } from 'app/core/_base/crud/models/summary-send-mail-model';
import { TruckReceipt } from '../models/truck.receipt';




@Injectable({
  providedIn: 'root'
})
export class TruckReceiptService {


 /**
  * Url for send emails by  truck Receipt API Rest
  */
 private API_SEND_EMAILS_URL = environment.ipserver + 'operations/private/truckReceipt/sendEmail';

 private API_SEND_SECOND_HOME_EMAILS_URL = environment.ipserver + 'operations/private/truckReceipt/sendEmailSecondHome';

 /**
  * Url for truck Receipt search API Rest
  */
 private API_SEARCH_URL = environment.ipserver + 'operations/private/truckReceipt/generate';
 private API_SEARCH_SECOND_HOME_URL = environment.ipserver + 'operations/private/truckReceipt/generateSecondHome';

 /**
  * Url for truck Receipt get orders with second home API Rest
  */
 private API_ORDERS_SECOND_HOME_URL = environment.ipserver + 'operations/private/truckReceipt/getOrdersWithSecondHome';



 constructor(
     private httpClient: HttpClient
 ) { }


 /**
  * Method that send a list of emails from warehouse by calling a rest service
  * @author Rosa Korse
  * @since 2020-05-20
  * @return Observable with a array of strings address code
  */
 public sendEmailsFromWarehouse(emails: string[], filters: TruckReceipt): Observable<SummarySendMail[]> {
    let paramsForReq = new HttpParams()
            .set('division', filters.division)
            .set('orderNumber', filters.orderNumber)
            .set('shipDate', filters.shipDate)
            .set('warehouse', filters.warehouse)
            .set('voyageNumber', filters.voyageNumber)
            .set('vesselName', filters.vesselName);

    if (filters.maximumDateAllowed) {
        paramsForReq = paramsForReq.set('maximumDateAllowed', filters.maximumDateAllowed);
    }
    // const type = 'text' as 'json';
    let header = new HttpHeaders();
    header = header.append('content-type', 'application/json');
    return this.httpClient.post<SummarySendMail[]>(this.API_SEND_EMAILS_URL, emails, { params: paramsForReq, headers: header });
 }

 public sendEmailsSecondHomeFromWarehouse(emails: string[], filters: TruckReceipt): Observable<SummarySendMail[]> {
    let paramsForReq = new HttpParams()
            .set('division', filters.division)
            .set('orderNumber', filters.orderNumber)
            .set('shipDate', filters.shipDate)
            .set('warehouse', filters.warehouse)
            .set('voyageNumber', filters.voyageNumber)
            .set('vesselName', filters.vesselName);

    if (filters.maximumDateAllowed) {
        paramsForReq = paramsForReq.set('maximumDateAllowed', filters.maximumDateAllowed);
    }
    // const type = 'text' as 'json';
    let header = new HttpHeaders();
    header = header.append('content-type', 'application/json');
    return this.httpClient.post<SummarySendMail[]>(this.API_SEND_SECOND_HOME_EMAILS_URL, emails, { params: paramsForReq, headers: header });
 }

 /**
  * Method that Search for Truck Recipts
  * @author Rosa Korse
  * @since 2021-04-09
  * @return Observable
  */
 public searchTruckReceipts(filters: TruckReceipt): Observable<any> {
    let paramsForReq = new HttpParams()
        .set('division', filters.division)
        .set('orderNumber', filters.orderNumber)
        .set('shipDate', filters.shipDate)
        .set('warehouse', filters.warehouse)
        .set('voyageNumber', filters.voyageNumber)
        .set('vesselName', filters.vesselName);

    if (filters.maximumDateAllowed) {
        paramsForReq = paramsForReq.set('maximumDateAllowed', filters.maximumDateAllowed);
    }

    const type = 'text' as 'json';
    return this.httpClient.post(this.API_SEARCH_URL, '', { params: paramsForReq, responseType: type });
 }

  /**
  * Method that Search for Truck Recipts
  * @author Rosa Korse
  * @since 2021-04-09
  * @return Observable
  */
  public searchSecondHomeTruckReceipts(filters: TruckReceipt): Observable<any> {
    let paramsForReq = new HttpParams()
        .set('division', filters.division)
        .set('orderNumber', filters.orderNumber)
        .set('shipDate', filters.shipDate)
        .set('warehouse', filters.warehouse)
        .set('voyageNumber', filters.voyageNumber)
        .set('vesselName', filters.vesselName);

    if (filters.maximumDateAllowed) {
        paramsForReq = paramsForReq.set('maximumDateAllowed', filters.maximumDateAllowed);
    }

    const type = 'text' as 'json';
    return this.httpClient.post(this.API_SEARCH_SECOND_HOME_URL, '', { params: paramsForReq, responseType: type });
 }

 /**
  * Method that retrieves orders with second home information
  * @author Implemented via AI
  * @since 2026-01-19
  * @param filters TruckReceipt object containing the filter parameters
  * @return Observable with the orders that have second home
  */
 public getOrdersWithSecondHome(filters: TruckReceipt): Observable<any> {
    let paramsForReq = new HttpParams()
        .set('division', filters.division)
        .set('orderNumber', filters.orderNumber)
        .set('shipDate', filters.shipDate)
        .set('warehouse', filters.warehouse)
        .set('voyageNumber', filters.voyageNumber)
        .set('vesselName', filters.vesselName);

    if (filters.maximumDateAllowed) {
        paramsForReq = paramsForReq.set('maximumDateAllowed', filters.maximumDateAllowed);
    }

    return this.httpClient.post<any>(this.API_ORDERS_SECOND_HOME_URL, null, { params: paramsForReq });
 }

 /**
  * Method that retrieves orders with second home information by order number only
  * @author Implemented via AI
  * @since 2026-01-20
  * @param orderNumber Order number to search
  * @return Observable with the orders that have second home
  */
 public getOrdersWithSecondHomeByOrderNumber(orderNumber: string): Observable<any> {
    const paramsForReq = new HttpParams()
        .set('orderNumber', orderNumber);

    return this.httpClient.post<any>(this.API_ORDERS_SECOND_HOME_URL, null, { params: paramsForReq });
 }

}
